import { RatioImage } from "@components/anti/Image"
import SectionWithSlider from "@components/global/SectionWithSlider"
import { dataLayerClickExperience } from "lib/datalayer"
import { convertHtmlToReact, convertJson, imgUrl } from "src/mixins"

function HomeExperience({ data, locale }) {
  return (
    <div className="sc-home-experience-wrapper">
      <div className="wrapper-ellipse">
        <RatioImage
          ratio="r-4-3"
          src="/img/misc/img_misc-home-experience-ellipse.png"
          alt="logo"
        />
      </div>
      <SectionWithSlider
        sectionName="sc-home-experience"
        data={convertJson(data.items)?.map((item) => ({
          title: item[`title_${locale}`],
          text: convertHtmlToReact(item[`description_${locale}`]),
          img: imgUrl(item.image),
          linkCard: item?.link_url,
          // linkCardWithButton: true,
        }))}
        dataLayer={(item) => {
          dataLayerClickExperience({ experiences_name: item.title })
        }}
        title={data && data[`title_${locale}`]}
        text={convertHtmlToReact(data[`description_${locale}`])}
        slidesPerViewMobile={1.2}
        slidesPerViewDesktop={1.6}
        hasArrow
        linkCardWithButton
      />
    </div>
  )
}

export default HomeExperience
